
const namespaced = true
const state = {
  attributes: {},
  attributesTypes: [],
  loading: false,
  changedType: null,
  searchValue: '',
  allAttr: null,
  searchTypeValue: null,
  allAttrInCol: {},
  isNeedUpdate: false
}
const getters = {
  getFilterAttributes (state) {
    if (state.changedType) {
      if (state.searchValue) {
        return state.attributes[state.changedType].filter(el => el.name.toLowerCase().includes(state.searchValue.toLowerCase()))
      } else return state.attributes[state.changedType]
    } else return null
  },
  isLoad (state) {
    return state.loading
  },
  getAllAttributtes (state) {
    return state.attributes
  },
  getAllTypesAttributes (state) {
    if (state.attributesTypes.length > 0) {
      const newTypes = state.attributesTypes.map(type => {
        const typeName = type[0].toUpperCase() + type.slice(1)
        return {
          label: typeName.replaceAll('_', ' ').replace('type', ''),
          id: type
        }
      })
      if (state.searchTypeValue) {
        return newTypes.filter(el => el.label.toLowerCase().includes(state.searchTypeValue.toLowerCase()))
      }
      return newTypes
    }
  }
}
const mutations = {
  setSearchTypeValue (state, val) {
    state.searchTypeValue = val
  },
  setAttributes (state, { attributes, type }) {
    if (type) state.attributes[type] = attributes
    else state.attributes[state.changedType] = attributes
  },
  setChangedType (state, type) {
    state.changedType = type
  },
  changeSettingsSearch (state, search) {
    state.searchValue = search
  },
  setAllAttr (state, allAttr) {
    state.allAttr = allAttr
  },
  setAttrTypes (state, attributesTypes) {
    state.attributesTypes = attributesTypes
  }
}

let controller = new AbortController()
const actions = {
  async addOption ({ commit, rootState, state, dispatch }, option) {
    const cleanString = (option) => {
      let str = option
      str = str.toLowerCase().replaceAll('men', 'man')
      /* eslint-disable-next-line */
      str = str.split(/[\s_\/-]+/)
      const words = str.map(el => {
        if (
          el.endsWith('ss') || el.endsWith('x') || el.endsWith('ch') || el.endsWith('sh') || el.endsWith('o')
        ) {
          return el + 'es'
        } else if (el.endsWith('y')) {
          return el.replace(/(y)$/g, 'ies')
        } else if (el.endsWith('is')) {
          return el.replace(/(is)$/g, 'es')
        } else if (el.endsWith('f')) {
          return el.replace(/(f)$/g, 'ves')
        } else if (!el.endsWith('es') && !el.endsWith('s')) {
          return el + 's'
        } else return el
      })
      return words.join('')
    }
    const s1 = cleanString(option)
    let hasAttr = false
    state.attributes[state.changedType].forEach(el => {
      const s2 = cleanString(el.name)
      if (s1 === s2) {
        hasAttr = 'Has option:' + el.name
      }
    })
    if (hasAttr) return hasAttr
    else {
      const putOption = await fetch(`${rootState.api.host}${rootState.api.endpoint.attributes}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        body: JSON.stringify({
          type: state.changedType,
          name: option
        })
      })
      if (putOption.ok) {
        state.isNeedUpdate = true
        dispatch('getAttributes')
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Tag created'
          }
        }, { root: true })
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Something went wrong, try again later'
          }
        }, { root: true })
      }
      return false
    }
  },
  async getAttrsById ({ rootState }, ids) {
    const getAttrById = await fetch(`${rootState.api.host}${rootState.api.endpoint.attributes}?ids=${ids}`, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootState.user.accesToken
      }
    })
    if (getAttrById.ok) {
      const response = await getAttrById.json()
      if (response) return response.attributes
    }
    return false
  },
  getAllAttrInParts ({ rootState, state }, { col, subtable }) {
    if (!state.allAttrInCol[subtable]) state.allAttrInCol[subtable] = {}
    const allAttr = []
    rootState.parts.data[subtable].parts.forEach(el => {
      if (el.colIndex === col.colIndex) {
        el.data.forEach(data => {
          const hasAttr = allAttr.find(attr => attr.code === data.code)
          if (!hasAttr) allAttr.push(data)
        })
      }
    })
    state.allAttrInCol[subtable][col.colIndex] = allAttr
    return true
  },
  getAttributes ({ rootState, state, commit }) {
    const type = state.changedType
    if (state.attributes[type] && !state.isNeedUpdate) return
    state.loading = true
    return new Promise((resolve, reject) => {
      fetch(`${rootState.api.host}${rootState.api.endpoint.attributes}?type=${type}`, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
        .then(response => response.json())
        .then(async data => {
          await commit('setAttributes', { attributes: data.attributes, type: type })
          state.isNeedUpdate = false
          state.loading = false
          resolve(data.attributes)
        })
        .catch(error => reject(error))
    })
  },
  fetchAllAttributes ({ rootState, state, commit }, { searchAttr, typeAttr }) {
    if (controller) {
      controller.abort()
      controller = new AbortController()
    }
    state.loading = true
    let search = ''
    let type = ''
    if (searchAttr) search = `search=${searchAttr}`
    if (typeAttr) type = `&type=${typeAttr}`
    return new Promise((resolve, reject) => {
      fetch(`${rootState.api.host}${rootState.api.endpoint.attributes}?${search}${type}`, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        },
        signal: controller.signal
      })
        .then(response => response.json())
        .then(data => {
          commit('setAllAttr', data.attributes)
          state.loading = false
          resolve(data.attributes)
        })
        .catch(error => reject(error))
    })
  },
  fetchAttributesTypes ({ rootState, state, commit }) {
    return new Promise((resolve, reject) => {
      fetch(`${rootState.api.host}${rootState.api.endpoint.attributesTypes}`, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      })
        .then(response => response.json())
        .then(async data => {
          await commit('setAttrTypes', data)
          resolve(data)
        })
        .catch(error => reject(error))
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced
}
